module.exports = __webpack_public_path__ + "static/media/effectramedium.76766032.ttf";